import React, { Component } from 'react';



export class HorizontalLines extends Component {
  render() {
    const {startDay, endDay, margin, rectW, w, theme_colors } = this.props;

    const line_count = 8;
    const translate_x = margin.left;
    const translate_y = margin.legend + margin.top;

    const lines = [...Array(line_count).keys()].map(idx =>
      <line className="horizontal"
        key={idx}
        stroke={theme_colors.lines}
        x1={startDay > idx ? rectW : 0}
        x2={w - (endDay + 1 < idx ? rectW : 0)}
        y1={idx * rectW}
        y2={idx * rectW}
      />
    );
    return (<g transform={`translate(${translate_x}, ${translate_y})`}>{lines}</g>);
  }
}



export class VerticalLines extends Component {
  render() {
    const {noOfWeeks, startDay, endDay, h, margin, rectW, theme_colors } = this.props;

    const line_count = noOfWeeks + 1;
    const translate_x = margin.left;
    const translate_y = margin.legend + margin.top;

    const lines = [...Array(line_count).keys()].map((idx) =>
      (<line className="vertical"
        key={idx}
        stroke={theme_colors.lines}
        x1={idx * rectW}
        x2={idx * rectW}
        y1={idx === 0 ? startDay * rectW : 0}
        y2={idx === noOfWeeks ? (endDay + 1) * rectW : h}
      />)
    );
    return (<g transform={`translate(${translate_x}, ${translate_y})`}>{lines}</g>);
  }
}
